<template>

  <table class="table">

    <thead>
    <tr>
      <th scope="col">No</th>
      <!-- <th scope="col">Code</th> -->
      <th scope="col">Description</th>
      <th scope="col">Value</th>
      <th scope="col">Actions</th>
    </tr>
    </thead>


    <tbody>
    <tr v-if="dataList.length === 0">
      <td colspan="5" class="text-center">Empty data list</td>
    </tr>

    <tr v-for="(data, index) in dataList" :key="data">
      <td class="order-number">{{ index + 1 }}</td>
      <!-- <td class="text-left"><span v-tooltip="data.description">{{ data.code }}</span></td> -->
      <td class="text-left">{{ data.description }}</td>
      <td class="text-center">
        <span v-if="!data.isEdit">{{ data.value }}</span>
        <InputText class="form-control" v-model="data.value" :value="data.value" v-if="data.isEdit"></InputText>
      </td>
      <td class="actions">
        <button type="button" class="btn btn-outline-secondary" v-tooltip="'Edit'" @click="onEdit(data)" v-if="!data.isEdit">
          <i class="pi pi-pencil"></i>
        </button>

        <button type="button" class="btn btn-outline-secondary" v-tooltip="'Save changes'" @click="onSubmit(data)" v-if="data.isEdit">
          <i class="pi pi-save"></i>
        </button>

        <button type="button" class="btn btn-outline-secondary" v-tooltip="'Cancel'" @click="onCancel(data)" v-if="data.isEdit">
          <i class="pi pi-times"></i>
        </button>
      </td>
    </tr>
    </tbody>

  </table>

</template>

<script>

import apiService from "@/services/ApiService";
import InputText from "primevue/inputtext";

export default {
  name: "GeneralSettingForm",
  components: {InputText},
  data() {
    return {
      model: {
        id: '',
        value: ''
      },
      dataList: [{
        id: '',
        code: '',
        description: '',
        value: '',
        isEdit: false
      }],
      saving: false,
      dataFilter: {
        searchText: "",
      },
    }
  },
  methods: {
    onEdit(data){
      data.isEdit = true;
      this.model.id = data.id;
      this.model.value = data.value;
    },
    onCancel(data){
      data.isEdit = false;
      this.model.id = '';
      this.model.value = '';
    },
    onSubmit(data) {

      console.log(data);

      this.saving = true;

      this.model.id = data.id;
      this.model.value = data.value;

      console.log(this.model);

      apiService.post(`/generalsetting/edit`, this.model)
          .then(() => {

            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: 'General setting has been updated',
              life: 5000
            });

            this.loadGeneralSettings();

          })
          .catch(error => {
            console.log(error);
            this.$toast.add({
              severity: 'error',
              summary: 'Failed to update general setting',
              detail: error.response.data.Message,
              life: 5000
            });
          })
          .finally(() => {
            this.saving = false;
            this.model.id = '';
            this.model.value = ''
          });
    },
    loadGeneralSettings() {
      const params = {
        SearchText: this.dataFilter.searchText,
      };
      apiService
          .get("/generalsetting", {params: params})
          .then((response) => {
            this.dataList = response.data;
            this.dataList.forEach((item) => {
              item.isEdit = false;
            });
          })
          .catch((error) => {
            console.log(error);

            this.$toast.add({
              severity: "error",
              summary: "Failed to get general setting",
              detail: error.response.data.Message,
              life: 5000,
            });
          });
    },
  },
  mounted() {
    this.dataList = [];
    this.loadGeneralSettings();
  }
}
</script>


<style scoped>

</style>
